import { render, staticRenderFns } from "./CVV.vue?vue&type=template&id=2cfe1384&lang=pug"
import script from "./CVV.vue?vue&type=script&lang=js"
export * from "./CVV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports